import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "masthead" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Archief")
const _hoisted_5 = { class: "header__nav" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Personen")
const _hoisted_7 = { class: "header__user" }
const _hoisted_8 = { class: "header__user__handle" }
const _hoisted_9 = { class: "header__user__name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: { name: 'home' },
            class: "header__brand"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createElementVNode("nav", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: { name: 'persons' },
              class: "header__nav__link"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createElementVNode("section", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.name), 1)
            ])
          ])
        ])
      ]),
      _renderSlot(_ctx.$slots, "masthead")
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}